// extracted by mini-css-extract-plugin
export default {"button":"InsuranceListAddButton_button__pVztg"};